import { Flex, Icon, Text } from '@chakra-ui/react'
import { useEffect, useRef, useState } from 'react'
import { FaRegClock } from 'react-icons/fa'

interface HoldTimerProps {
  minutes: number
}

export const AppointmentHoldCountdown: React.FC<HoldTimerProps> = ({
  minutes,
}) => {
  const endTimeRef = useRef(new Date(Date.now() + minutes * 60000 + 1000))
  const [timeLeft, setTimeLeft] = useState<string>(
    `${minutes.toString().padStart(2, '0')}:00`
  )

  useEffect(() => {
    const updateCountdown = () => {
      const diff = Math.max(endTimeRef.current.getTime() - Date.now(), 0)
      const min = Math.floor(diff / 60000)
      const sec = Math.floor((diff % 60000) / 1000)
      setTimeLeft(
        `${min.toString().padStart(2, '0')}:${sec.toString().padStart(2, '0')}`
      )
    }

    updateCountdown()

    const interval = setInterval(updateCountdown, 1000)

    return () => clearInterval(interval)
  }, [])

  return (
    <Flex
      align="center"
      border="1px solid #4678E6"
      borderRadius="full"
      px={4}
      py={2}
      bg="transparent"
      color="#4678E6"
      fontWeight="semibold"
      width="fit-content"
    >
      <Icon as={FaRegClock} mr={2} />
      <Text m={0} fontSize="12px">
        We’ll hold your appointment for{' '}
        <Text as="span" fontWeight="bold">
          {timeLeft}
        </Text>
      </Text>
    </Flex>
  )
}
